export function feedbackSourceRange(note){
 const words=note?.words;
 if(!Array.isArray(words)||!words.length)return null;
 const start=Number(words[0].start),end=Number(words[words.length-1].end);
 return Number.isFinite(start)&&Number.isFinite(end)&&end>start?{start,end}:null;
}
export function feedbackBucket(note,replyCounts=new Map()){
 if(note.status==='accepted')return 'accepted';
 if(note.status==='resolved'||note.status==='dismissed')return 'resolved';
 if(note.status==='open'&&(replyCounts.get(note.id)||0)>0)return 'discussing';
 return 'needs';
}
export function feedbackCount(notes,filter,replyCounts=new Map()){
 if(filter==='all')return notes.length;
 if(filter==='needs')return notes.filter(note=>note.status==='open').length;
 return notes.filter(note=>feedbackBucket(note,replyCounts)===filter).length;
}
export function feedbackStatusLabel(status){
 return ({approved:'Approved',submitted:'Review submitted',changes_requested:'Changes requested',
 in_progress:'In progress',accepted:'Accepted',resolved:'Resolved',dismissed:'Dismissed'})[status]||status;
}
